import { useQuery } from "@tanstack/react-query";
import { invoiceQueryKeys } from "@/queries/invoice";
import { useAuth } from "@/providers/auth";
import { recurringInvoiceList } from "@/queries/invoice/recurring/list";

export const useRecurringInvoices = () => {
  const { cognitoId, clientId, userRole } = useAuth();
  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useQuery({
    queryKey: invoiceQueryKeys.recurringInvoice.list(userId),
    queryFn: () => {
      // Re-use the fetch logic from the recurring list module
      const options = recurringInvoiceList.queryOptions(userId);
      return options.queryFn!();
    },
    enabled: !!userId,
  });
};
